module.exports = __webpack_public_path__ + "static/media/screenshot4.be8745b6.png";